import React from "react"
import {useModal, useSolution, useSolutionRepository} from "../AppContext"
import {solutionDispatchShare} from "../Modal/SolutionRepository"
import {RoomName} from "./RoomName"
import {iconShare} from "../Helper/Icons"
import style from "./Share.css"

export const ShareIcon = () => {
    const solutionRepository = useSolutionRepository()
    const modal = useModal()
    const solution = useSolution()
    const saveName = RoomName()

    const actionShare = () => {
        solutionRepository.add(solution.getSavedRoom(), saveName)
        modal.openSolutionLoad()
        solutionDispatchShare(solution.getCode())
    }

    return <div className={style.share} onClick={actionShare}>{iconShare}</div>
}

export const ShareText = ({children}) => {
    const solutionRepository = useSolutionRepository()
    const modal = useModal()
    const solution = useSolution()
    const saveName = RoomName()

    const actionShare = () => {
        solutionRepository.add(solution.getSavedRoom(), saveName)
        modal.openSolutionLoad()
        solutionDispatchShare(solution.getCode())
    }

    return <div className={style.shareCustom} onClick={actionShare}>{children}</div>
}
